import { isWidthDown } from '@material-ui/core';

type TWidth = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;

export const isMobile = (width: TWidth) => {
    return width && isWidthDown('sm', width);
};
